import { UseFieldArrayReturn, useFormContext } from 'react-hook-form';
import {
    ISaveJobForm,
    SAVE_JOB_FORM_VALUES,
} from '../../../../../common';
import { useEffect } from 'react';

interface UseJobQuestionsProps {
    questionsArray: UseFieldArrayReturn<
        ISaveJobForm,
        SAVE_JOB_FORM_VALUES.QUESTIONS,
        'id'
    >;
}

export const useJobQuestions = ({ questionsArray }: UseJobQuestionsProps) => {
    const methods = useFormContext<ISaveJobForm>();
    const { control, watch } = methods;
    const { append } = questionsArray;

    const watchedSelectedJob = watch(SAVE_JOB_FORM_VALUES.QUESTIONS_SELECTED_JOB);

    useEffect(() => {
        if (watchedSelectedJob?.value) {
            console.log('Selected job for questions:', watchedSelectedJob);
            // TODO: Fetch questions for selected job
        }
    }, [watchedSelectedJob]);

    const handleAddQuestion = () => {
        append({
            id: `new_${new Date().getTime()}`,
            questionTitle: '',
            questionType: null,
            isRequired: false,
            isDealbreaker: false,
            isDateRange: false,
            dateFrom: null,
            dateTo: null,
            options: [],
            deletedOptions: [],
            dealbreakerAnswer: null,
            bandFrom: null,
            bandTo: null,
            bandOptionValue: null,
        });
    };

    return {
        control,
        handleAddQuestion,
        watchedSelectedJob,
    };
};
